
import { takeLatest, put, call } from 'redux-saga/effects';
import * as caseCreateActions from './actions'
import { HTTP_HEADERS } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import { CORE_API, AUTH_SERVER, REPORT } from '../../../config';



export function* corporateSearch(action) {

    let requestUrl = `${CORE_API}/corporate/autocomplete/${action.parameter.toLowerCase()}/${action.search}`;
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(caseCreateActions.searchCorporateResultsSuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.searchCorporateResultsFailure(err))
    }
}
export function* getCorporateSearch() {
    yield takeLatest(caseCreateActions.SEARCH_CORPORATE_PARAMETER, corporateSearch);
}
export function* counterpartySearch(action) {//counterparty/autocomplete/name/{searchText}
    const parameter = action.parameter.toLowerCase();
    const searchText = action.search ? action.search.trim() : '';
    if (!searchText) {
        return;
    }


    let requestUrl;
    if (action.caseType === 'DOMESTIC') {
        requestUrl = `${CORE_API}/counterparty/autocomplete/${parameter}/${action.search}`;
    } else {
        const pageNo = action.pageNo || 1;
        const pageSize = action.pageSize || 10;
        requestUrl = `${CORE_API}/counterparty/autocomplete/${parameter}/${encodeURIComponent(searchText)}/${pageNo}/${pageSize}`;
        if (action.countryCode && action.countryName) {
            requestUrl = `${requestUrl}?countryCode=${encodeURIComponent(action.countryCode)}&countryName=${encodeURIComponent(action.countryName)}`;
        }
    }
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(caseCreateActions.searchCounterpartyResultsSuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.searchCounterpartyResultsFailure(err))
    }
}
export function* getCounterpartySearch() {
    yield takeLatest(caseCreateActions.SEARCH_COUNTERPARTY_PARAMETER, counterpartySearch);
}

export function* counterpartytype() {
    let requestUrl = `${CORE_API}/product/counterpartyType`;
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(caseCreateActions.getCounterpartyTypeSuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.getCounterpartyTypeFailure(err)

        )
    }
}
export function* getCounterpartytype() {
    yield takeLatest(caseCreateActions.GET_COUNTERPARTY_TYPE, counterpartytype);
}

export function* reportCategory() {
    let requestUrl = `${CORE_API}/product/reportCategory`;
 
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(caseCreateActions.getReportCategorySuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.getReportCategoryFailure(err)

        )
    }
}
export function* getReportCategory() {
    yield takeLatest(caseCreateActions.GET_REPORT_CATEGORY, reportCategory);
}

export function* reportFrontCover() {
    let requestUrl = `${CORE_API}/product/reportFrontCover`;
 
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(caseCreateActions.getReportFrontCoverListSuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.getReportFrontCoverListFailure(err)

        )
    }
}
export function* getReportFrontCoverList() {
    yield takeLatest(caseCreateActions.GET_REPORT_FRONT_COVER_LIST, reportFrontCover);
}

export function* fetchPortfolioCount() {
    let requestUrl = `${CORE_API}/portfolio/reportcategory/count`;

    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(caseCreateActions.getPortfolioCountSuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.getPortfolioCountFailure(err)

        )
    }
}
export function* getPortfolioCount() {
    yield takeLatest(caseCreateActions.GET_PORTFOLIO_COUNT, fetchPortfolioCount);
    
}
export function* userList(action) {//counterparty/autocomplete/name/{searchText}

    let requestUrl = `${AUTH_SERVER}/user/autocomplete/corporate/${action.id}/${action.search}`;
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(caseCreateActions.getUsersSuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.getUsersFailure(err))
    }
}
export function* getUserList() {
    yield takeLatest(caseCreateActions.GET_USERS, userList);
}

export function* productList(action) {
    let requestUrl = `${REPORT}/product/list/corporate/${action.id}/counterparty/${action.search}/${action.selectedProductCategory}/reportCategory/${action.reportCategory}`;
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(caseCreateActions.getProductsSuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.getProductsFailure(err))
    }
}
export function* getProductList() {
    yield takeLatest(caseCreateActions.GET_PRODUCTS, productList);
}

export function* allDivisionSubsidiary(action) {
    let requestUrl = `${REPORT}/corporate/divisionSubsidiary/${action.id}`;
    try {
        const searchResult = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });
        yield put(caseCreateActions.getAllDivisionSubsidiarySuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.getAllDivisionSubsidiaryFailure(err))
    }
}
export function* getAllDivisionSubsidiary() {
    yield takeLatest(caseCreateActions.GET_ALLDIVISIONSUBSIDIARY, allDivisionSubsidiary);
}

export function* createCaseSaga(action) {//counterparty/autocomplete/name/{searchText}
    let requestUrl = `${CORE_API}/case/`;
    try {
        const searchResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(caseCreateActions.createCaseSuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.createCaseFailure(err))
    }
}
export function* createCase() {
    yield takeLatest(caseCreateActions.CREATE_CASE, createCaseSaga);
}

export function* createBulkBuySaga(action) {//counterparty/autocomplete/name/{searchText}
    let requestUrl = `${CORE_API}/case/bulk`;
    try {
        const searchResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(caseCreateActions.createCaseSuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.createCaseFailure(err))
    }
}
export function* createBulkBuy() {
    yield takeLatest(caseCreateActions.CREATE_BULK_BUY, createBulkBuySaga);
}

export function* createCounterpartySaga(action) {
    let requestUrl = `${CORE_API}/counterparty/`;
    try {
        const searchResult = yield call(request, requestUrl, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(caseCreateActions.createCounterpartySuccess(searchResult.data));//toggleModalCreate

    } catch (err) {
        yield put(caseCreateActions.createCounterpartyFailure(err))
    }
}
export function* createCounterparty() {
    yield takeLatest(caseCreateActions.CREATE_COUNTERPARTY, createCounterpartySaga);
}

export function* getZoneList(action) {

    let requestUrl = `${CORE_API}/zone/list`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });//yield call(Axios.get, requestURL, { headers: httpHeaders });
        yield put(caseCreateActions.getZoneSuccess(result.data));
    } catch (err) {
        yield put(caseCreateActions.getZoneFailure(err))
    }
}
export function* getZone() {
    yield takeLatest(caseCreateActions.GET_ZONE, getZoneList);
}
export function* getZoneForStateSaga(action) {

    let requestUrl = `${CORE_API}/stateToZone/state/${action.data}`;

    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });//yield call(Axios.get, requestURL, { headers: httpHeaders });
      
        yield put(caseCreateActions.getZoneForStateSuccess(result.data));
    } catch (err) {

        yield put(caseCreateActions.getZoneForStateFailure(err))

    }

}

export function* getZoneForState() {

    yield takeLatest(caseCreateActions.GET_ZONE_FOR_STATE, getZoneForStateSaga);

}
export function* getIndianStatesList(action) {

    let requestUrl = `${CORE_API}/counterparty/states`;
    try {
        const result = yield call(request, requestUrl, { data: '', method: 'GET', headers: HTTP_HEADERS });//yield call(Axios.get, requestURL, { headers: httpHeaders });
        yield put(caseCreateActions.getIndianStatesSuccess(result.data));
    } catch (err) {

        yield put(caseCreateActions.getIndianStatesFailure(err))
    }
}
export function* getIndianStates() {
    yield takeLatest(caseCreateActions.GET_INDIANSTATES, getIndianStatesList);
}

export function* createCaseSubscriptionOrDatabaseSaga(action) {//counterparty/autocomplete/name/{searchText}
    let requestUrl = `${CORE_API}/case/instantReport?counterpartyId=${action.data.counterpartyId}&reportType=${action.data.reportType}&caseType=${action.data.caseType}&requestType=${action.data.requestType}`; 
    try {
        const searchResult = yield call(request, requestUrl, { data:'', method: 'GET', headers: HTTP_HEADERS });
        yield put(caseCreateActions.createSubscriptionDatabaseCaseSuccess(searchResult.data));
    } catch (err) {
        yield put(caseCreateActions.createSubscriptionDatabaseCaseSFailure(err))
    }
}
export function* createCaseSubscriptionOrDatabase() {
    yield takeLatest(caseCreateActions.CREATE_SUBSCRIPTION_DATABASE_CASE, createCaseSubscriptionOrDatabaseSaga);
}

